import React, {useRef, useMemo, useState, useEffect} from 'react';
import ReactQuill, {Quill}                            from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './PostEditor.css';
import {common}                                       from '../../../common/common';
// @ts-ignore
import ImageResize                                    from 'quill-image-resize';
import {isMobile} from 'react-device-detect';
import QuillImageDropAndPaste                         from '../../quillEditor/ImageDropAndPaste';
import CustomVideo from "../../quillEditor/CustomVideo";
// @ts-ignore
import AutoLinks from 'quill-auto-links';
import FileUpload from "../fileUpload/FileUpload";
// @ts-ignore
import Table from 'quill-table';
// import 'quill-table/src/css/quill.table.css';

Quill.register('modules/ImageResize', ImageResize);
Quill.register('modules/imageDropAndPaste', QuillImageDropAndPaste);
CustomVideo.blotName = 'video';
CustomVideo.className = 'ql-video';
CustomVideo.tagName = 'video';
Quill.register('formats/video', CustomVideo);
Quill.register('modules/autoLinks', AutoLinks);

Quill.register({
    'modules/table': Table,
});

export default function PostEditor(props: { readOnly: boolean, QuillRef: any, initContent: any, boardId?: any }) {
	console.log('[PostEditor]');
	const [state, setState] = useState('');

	useEffect(() => {
		if (props.initContent !== '') {
			setState(props.initContent)
		}
	}, [props.initContent])

	const handler: any = common.imageHandler(props.QuillRef);

// quill에서 사용할 모듈을 설정하는 코드 입니다.
// 원하는 설정을 사용하면 되는데, 저는 아래와 같이 사용했습니다.
// useMemo를 사용하지 않으면, 키를 입력할 때마다, imageHandler 때문에 focus가 계속 풀리게 됩니다.
	const modules = useMemo(
			() => ({
				toolbar: {
					container: [
						['bold', 'italic', 'underline', 'strike', 'blockquote'],
						[{size: ['small', false, 'large', 'huge']}, {color: []}],
						[
							// {list: 'ordered'},
							// {list: 'bullet'},
							{indent: '-1'},
							{indent: '+1'},
							{align: []},
						],
						['image', 'video'],
						['link'],
					],
					handlers: {
						image: handler,
					},
				},
                table: false,
                ImageResize: {
					parchment: Quill.import('parchment'),
				},
				imageDropAndPaste: {},
				autoLinks: true
			}),
			[],
	);

	function handleChange(e: any) {
		if (e.indexOf('<img src="data:image/png;base64') > -1) {
			return;
		}
		console.log(e);
		e = e.replace('<img src="//:0">', '');
		setState(e);
		// props.setState({
		// 	...props.state,
		// 	contents: e,
		// });
	}

	return (
			<>
				<ReactQuill
						style={{
							width: '100%',
							height: '100%',
						}}
						ref={(element) => {
							if (element !== null) {
								props.QuillRef.current = element;
								console.log(props.QuillRef.current)
							}
						}}
						readOnly={props.readOnly}
						value={state}
						onChange={(e) => handleChange(e)}
						modules={modules}
						theme="snow"
						placeholder=""
				/>
			</>
	);
};
